import {IReportRowLinks} from 'components/table-report/table-report-types';
import {IFieldMeta, EMetaActionType} from 'entities/metadata';
import {IFileDto} from 'shared/types/files';
import {TLinkDto} from 'shared/types/links';

export interface IRequestSliceState {
    requestData: IRequestData | undefined;
    requestStatuses: IRequestStatusesInfo | undefined;
    requestFormFields: IFieldMeta[] | undefined;
    submitButtonActionType: EMetaActionType | undefined;
}
interface IAddresseeEntity {
    id: number;
    firstName: string;
    lastName: string;
    fullName: string;
    departmentName?: string;
    displayName?: string;
    middleName?: string;
}

interface ICreateByData {
    id: number;
    email: string;
    enabled: boolean;
    name: string;
    position: string;
}

export interface IRequestTypesInfo {
    id: string;
    lookupType: string;
    lookupCode: string;
    meaning: string;
    attribute1: string;
    attribute2: string;
    attribute3: string;
    attribute4: string;
    attribute5: string;
}

interface ITopicRequestTypeData {
    id: number;
    description: string;
    type?: IRequestTypesInfo;
    typeCode?: string;
}

interface ICategoryData {
    id: number;
    categoryCode: string;
    categoryName: string;
    createdBy: ICreateByData;
    topicRequestTypes: ITopicRequestTypeData;
}

interface ITopicStatusData {
    id: number;
    lookupType: string;
    lookupCode: string;
    meaning: string;
    description: string;
    parentLookupValueId: number;
}
export interface IFlexFieldList{
    attributeColumnName: string;
    segmentSeqNum: number;
    segmentColumnName: string;
    segmentUserName: string;
    segmentValue: string;
    global: boolean;
    displayed: boolean;
}

interface ITaxPeriodDto {
    id: number;
    startDate: Date;
    endDate: Date;
    taxPeriodName: string;
    taxPeriodStatusId: number;
    taxPeriodStatusCode: string;
    taxPeriodStatusMeaning: string;
    startDateStr: string;
    endDateStr: string;
    taxPeriodTypeId: number;
}

interface IPermission {
    id: number;
    name: string;
}

interface IRole {
    authority: string;
    description: string;
    enabledFlag: string;
    externalCode: string;
    externalRole: string;
    id: number;
    name: string;
    permissions: IPermission[];
    version: number;
}

interface IGroup {
    code: string;
    flag: string;
    id: number;
    name: string;
    roles: IRole[];
    topicRequestTypes: ITopicRequestTypeData[];
    version: number;
}

export interface IRequestInfo {
    id: string;
    period: ITaxPeriodDto;
    addressees: IAddresseeEntity[];
    attachmentList: IFileDto[];
    category: ICategoryData;
    topicRequestType: ITopicRequestTypeData;
    content: string;
    fromUser: string;
    subject: string;
    toUser: string;
    idRequestComment: string;
    requestReplies: any;
    updateDate?: Date;
    topicStatus: ITopicStatusData;
    flexFieldList : any[];
    taxTypeId: number;
    requestNum: number;
    numberRequest: string;
    requestType: string;
    requestDate:Date;
    status: ITopicStatusData;
    rating?: number;
    ddUrlDto?: TLinkDto;
}

export interface IRequestReply {
    idRequestComment: number;
    createDate: string;
    author: string;
    addressees: string;
    content: string;
    attachments: IFileDto[];
}

export interface ITopicCommentDto  {
    id: string | number;
    idRequestComment: string;
    addressees: string;
    author: string;
    createDate: Date;
    content: string;
    attachments: IFileDto[];
    status: ITopicStatusData;
    documentDate: string;
    numberRequest: string;
    estimationDate: Date;
    groups: IGroup[];
    prolongationDate: Date;
    prolongationDateResponse: Date;
    topicStatus: string;
    addresseesId: number[];
    reasonsProlongationId: number;
    partialExecution: string;
    rating: number;
}
export interface IProlongationRequest {
    id: string | number;
    idRequestComment: string;
    addressees: string;
    author: string;
    createDate: Date;
    content: string;
    prolongationDate:Date;
    prolongationDateResponse: Date;
    attachments: IFileDto[];
}

export interface ITopicReportInfo {
    templateCode: string;
    docId: string;
    reportSectionName: string;
    reportParameters: string;
    reportRowLinks: IReportRowLinks[];
}

export interface IRequestData {
    requestReplies: ITopicCommentDto[];
    requests: IRequestInfo;
    responseReplies: ITopicCommentDto[];
    requestResponse: ITopicCommentDto;
    prolongationRequest: ITopicCommentDto;
    prolongationResponse: ITopicCommentDto;
    requestRejection?: ITopicCommentDto;
    enabledLink: boolean;
    topicReportInfo?: ITopicReportInfo;
    clarificationFlag: string;
}

interface IRequestStatusesDate{
    statuses: ERequestStatus[];
}
export interface IRequestStatusesInfo {
    [key: string]: IRequestStatusesDate;
}

export enum ERequestStatus {
    // Common status
    /**
     * ЗАКРЫТЬ ЗАПРОС
     */
    CLOSE_REQUEST = 'CLOSE_REQUEST',
    /**
     * КОММЕНТАРИЙ
     */
    COMMENT_REQUEST = 'COMMENT_REQUEST',
    SEND_MESSAGE = 'SEND_MESSAGE',
    /**
     * КНОПКА УПРАВЛЕНИЯ ЧАТОМ
     */
    BUTTON_CONTROL_COLLAPSE = 'BUTTON_CONTROL_COLLAPSE',
    /**
     *  ВЗЯТЬ В РАБОТУ
     */
    TAKE_TO_WORK_REQUEST = 'TAKE_TO_WORK_REQUEST',
    TAKE_TO_WORK_REQUEST_NOT_DATE = 'TAKE_TO_WORK_REQUEST_NOT_DATE',
    /**
     * НАЗНАЧИТЬ ОТВЕТСТВЕННОГО
     */
    ASSIGN_RESPONSIBLE = 'ASSIGN_RESPONSIBLE',
    /**
     * ОТВЕТ НА ЗАПРОС
     */
    REQUEST_RESPONSE = 'REQUEST_RESPONSE',
    /**
     * ЗАПРОСИТЬ ПРОДЛЕНИЕ
     */
    REQUEST_PROLONGATION = 'REQUEST_PROLONGATION',
    /**
     * СОЗДАТЬ ОТВЕТ
     */
    GENERATE_RESPONSE = 'GENERATE_RESPONSE',
    /**
     * ОТВЕТ НА ЗАПРОС
     */
    REPLY_REQUEST = 'REPLY_REQUEST',
    /**
     * ОТПРАВИТЬ ЗАПРОС НА УТВЕРЖДЕНИЕ
     */
    SEND_FOR_APPROVAL_REQUEST = 'SEND_FOR_APPROVAL_REQUEST',
    /**
     *  ОТПРАВИТЬ ОТВЕТ НА ЗАПРОС
     */
    REQUEST_RESPONSE_SEND = 'REQUEST_RESPONSE_SEND',
    /**
     * Запрос о продлении
     */
    PROLONGATION_REQUEST = 'PROLONGATION_REQUEST',
    /**
     * Ответ на запрос о продлении
     */
    PROLONGATION_RESPONSE = 'PROLONGATION_RESPONSE',
    /**
     * Сформировать отказ
     */
    GENERATE_REJECTION_RESPONSE = 'GENERATE_REJECTION_RESPONSE',
    /**
     * EDIT_RESPONSE
     */
    EDIT_RESPONSE = 'EDIT_RESPONSE',
    /**
     * Удалить
     */
    DELETE_REQUEST = 'DELETE_REQUEST',
    /**
     * APPROVE
     */
    APPROVE_REQUEST = 'APPROVE_REQUEST',
    /**
     * REJECT
     */
    REJECT = 'REJECT',
    REJECT_REQUEST = 'REJECT_REQUEST',
    GENERATE_ADD_PLACEMENT_DOC_RESPONSE = 'GENERATE_ADD_PLACEMENT_DOC_RESPONSE',
    /**
     * RATE
     */
    RATE_REQUEST='RATE_REQUEST',
    FINALLY_CLOSED='FINALLY_CLOSED',

    /**
     * D365
     */
    REQUEST_FROM_D365 = 'REQUEST_FROM_D365',
    /**
     * Обновить реестр документов
     */
    UPDATE_DOC_JOURNAL = 'UPDATE_DOC_JOURNAL',
}
